import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "About", href: "#about" },
  { label: "Expertise", href: "#expertise" },
  { label: "Ventures", href: "#ventures" },
  { label: "Clients", href: "#clients" },
  { label: "Industries", href: "#industries" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 cursor-pointer group">
          <span
            className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md font-heading font-bold text-lg tracking-tight transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-950"
            }`}
          >
            AH
          </span>
          <span
            className={`font-heading font-semibold text-base md:text-lg tracking-tight transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            Alon Hahamy
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 text-sm font-medium rounded-md cursor-pointer transition-colors whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50 dark:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
            Get in touch
          </a>
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          onClick={() => setMobileOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 space-y-1">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-3 text-sm font-medium text-foreground-800 rounded-md hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            className="block mt-2 text-center rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50 dark:text-foreground-950 cursor-pointer"
          >
            Get in touch
          </a>
        </div>
      )}
    </header>
  );
}